enum EnumResponsabilidadeString {
  INDICADOR = 'Indicador',
  REPRESENTANTE = 'Representante',
  ESTABELECIMENTO = 'Estabelecimento',
  RESPONSAVEL = 'Responsável',
  INCENTIVADOR = 'Incentivador',
}

export default EnumResponsabilidadeString;
